import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import _ from 'lodash'
import QRCode from 'qrcode.react'

import InvoiceModal from './invoice_modal'
import { setCode, toggleInvoiceDialog } from 'modules/deposits'
import {
  getPaymentAddresses,
  getPaymentAddressByCurrency
} from 'modules/deposits/payment_addresses'
import { currency_icon } from 'core/utils'
import parametersSelector from 'selectors/parameters'
import depositsSelector from 'selectors/deposits'
import jsonSelector from 'selectors/json'

const TabContent = ({
  getPaymentAddressByCurrency,
  setCode,
  toggleInvoiceDialog,
  getMinPaymentAmount,
  config_parameters,
  available_currencies,
  deposits,
  user_addresses
}) => (
  <Grid container direction="column" spacing={40}>
    <Grid item>
      <Grid container>
        {_.map(available_currencies, ({ name: currency_name }, currency_code) => (
          <Grid item key={currency_code}>
            <Button
              raised={deposits.code === currency_code}
              color={deposits.code === currency_code ? 'primary' : 'default'}
              dense
              value={currency_code}
              onClick={() => setCode(currency_code)}
            >
              {currency_code === 'USD' ? (
                <Translate value="main.step.make_deposit.usd_tab_title" />
              ) : (
                currency_name
              )}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Grid>
    <Grid item>
      <Grid container spacing={40} id="myTabContent" className="tab-content deposit-box gray-box">
        <div>
          {(({ name: currency_name }, currency_code) => (
            <div key={currency_code}>
              {currency_code === 'USD' ? (
                <Grid container direction="column" key={currency_code} id="USD">
                  {getMinPaymentAmount('USD') > 0 && (
                    <Grid item>
                      <div className="alert alert-dismissible alert-warning">
                        <Translate
                          value="deposits.alert_html"
                          min_amount_for_transfer={I18n.l(getMinPaymentAmount('USD'))}
                          currency_code="USD"
                          dangerousHTML
                        />
                      </div>
                    </Grid>
                  )}
                  <Grid item>
                    <Translate
                      value="main.step.make_deposit.usd_description_html"
                      min_amount_for_transfer={I18n.l(
                        config_parameters['invoiced.min_amount_for_transfer']
                      )}
                      dangerousHTML
                    />
                  </Grid>
                  <Grid item>
                    <Button raised color="primary" onClick={toggleInvoiceDialog}>
                      {I18n.t('deposits.generate_invoice')}
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  direction="column"
                  id={currency_code}
                  key={currency_code}
                  spacing={40}
                >
                  {!user_addresses[currency_code] && (
                    <Grid item>
                      <Button
                        raised
                        color="primary"
                        className="get-address"
                        onClick={() => getPaymentAddressByCurrency(currency_code)}
                      >
                        {I18n.t('deposits.get_address')}
                      </Button>
                    </Grid>
                  )}
                  <Grid item>
                    {user_addresses[currency_code] && (
                      <div className="payment-block">
                        <Grid container spacing={40}>
                          <Grid item md={6} xs={12} sm={12} className="text-center left">
                            <p className="title">{I18n.t('deposits.deposit_by_qr_code')}</p>
                            <div className="box left quare-code">
                              <QRCode
                                value={user_addresses[currency_code].payment_address}
                                level="H"
                                size={159}
                              />
                            </div>
                          </Grid>
                          <Grid item md={6} xs={12} sm={12} className="text-center right">
                            <p className="title">{I18n.t('deposits.or_direct_deposit_to')}</p>
                            <div className="box right" style={{ wordBreak: 'break-all' }}>
                              {currency_icon(currency_code, 'currency-tab-bg')}
                              <div className="vertical-align-in-block">
                                <p className="payment-address">
                                  {user_addresses[currency_code].payment_address}
                                </p>
                                {currency_code === 'NXT' && (
                                  <p className="pubkey">{user_addresses[currency_code].pub_key}</p>
                                )}
                                <p className="dest-tag">{user_addresses[currency_code].dest_tag}</p>
                              </div>
                            </div>
                            <br />
                          </Grid>
                        </Grid>
                        <br />
                      </div>
                    )}
                    {getMinPaymentAmount(currency_code) > 0 && (
                      <div className="alert alert-dismissible alert-warning">
                        <Translate
                          value="deposits.alert_html"
                          min_amount_for_transfer={I18n.l(getMinPaymentAmount(currency_code), {
                            maximumFractionDigits: config_parameters['coin.currency_precision']
                          })}
                          currency_code={currency_code}
                          dangerousHTML
                        />
                      </div>
                    )}
                    <Translate
                      value="main.step.make_deposit.crypt_description_html"
                      dangerousHTML
                    />
                  </Grid>
                </Grid>
              )}
              {parseInt(config_parameters['system.auto_convert_balance_to_tokens'], 10) !== 0 ? (
                <Translate value="main.step.make_deposit.note_autoconvert_on_html" dangerousHTML />
              ) : (
                <Translate value="main.step.make_deposit.note_autoconvert_off_html" dangerousHTML />
              )}
            </div>
          ))(available_currencies[deposits.code], deposits.code)}
        </div>
      </Grid>
    </Grid>
  </Grid>
)

class TabContentContainer extends Component {
  componentDidMount() {
    const { getPaymentAddresses } = this.props
    getPaymentAddresses()
  }
  render() {
    return [<TabContent key="tc" {...this.props} />, <InvoiceModal key="im" />]
  }
}

const getMinPaymentAmount = config_parameters => currency_code =>
  config_parameters['min_payment_amount_by_currency'][currency_code]

const mapStateToProps = state => ({
  getMinPaymentAmount: getMinPaymentAmount(parametersSelector(state)),
  config_parameters: parametersSelector(state),
  available_currencies: parametersSelector(state).available_currencies,
  deposits: depositsSelector(state),
  user_addresses: jsonSelector('deposits.payment_addresses')(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getPaymentAddresses, getPaymentAddressByCurrency, setCode, toggleInvoiceDialog },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(TabContentContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/tab_content.js